<template>
  <div
    v-loading="dataLoading"
    element-loading-text="Loading, please wait..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-dialog
      title="Export Data"
      :visible.sync="confirmToExportDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      size="tiny"
    >
      <div class="dialog">{{exportDialogTip}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleExportExcel()">OK</el-button>
        <el-button @click="confirmToExportDialogVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
    <!--Export data弹框-->

    <el-dialog
      title="Remove Data"
      :visible.sync="confirmToRemoveDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      size="tiny"
    >
      <div class="dialog">Confirm to remove?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmToRemoveDialogVisible = false">Cancel</el-button>
        <el-button type="danger" @click="confirmToRemove">OK</el-button>
      </span>
    </el-dialog>

    <el-collapse v-if="showForm" v-model="activeNames">
      <!--form表单折叠板-->
      <el-collapse-item name="1">
        <template slot="title">
          <span style="text-align: left;width: 100%;color: red" v-if="showWordTip">{{wordTip}}</span>

          <span style="text-align: right;width: 100%; position: relative">
            <template v-if="activeNames.includes('1')">Collapse Filter</template>
            <template v-else>Expand Filter</template>
            &nbsp;
            <el-collapse-transition>
              <span class="ticket-mark" v-show="showTicketMark">*可点击下拉菜单，选择对应的ticket</span>
            </el-collapse-transition>
          </span>
        </template>

        <!-- 组件自有的功能 CategorySelectionControlMyDefault&&CategorySelectionControlMyDefaultDataProp
        目前more按钮已经隐藏，为防止后续需要，暂时将参数之类进行保存在注释中-->
        <div class="query-form" v-show="true">
          <el-form
            ref="queryForm"
            :model="pageSettingData"
            label-width="100px"
            label-position="top"
          >
            <el-row v-if="showPohFuzzyQuery">
              <div style="width:95px;float:left;line-height:32px;color:#606266;font-weight: 700;">
                诊所名称/编号
              </div>
              <div style="float:left;width:calc( 100% - 95px)">
                <el-input size="small" clearable v-model="poh_fuzzy_query"></el-input>
              </div>
            </el-row>
            <el-row :gutter="20">
              <div v-for="(item, index) in pageSettingData.form" :key="index">
                <el-col
                  :xs="12"
                  :sm="8"
                  :md="6"
                  :lg="8"
                  v-if=" item.form_field_query_type === formType.DATE_RANGE  || item.form_field_query_type === formType.DATE_TIME_RANGE "
                >
                  <template>
                    <!-- DATE RANGE -->
                    <el-form-item
                      v-if="item.form_field_query_type === formType.DATE_RANGE"
                      :label="item.view_field_label"
                    >
                      <el-row :gutter="10">
                        <el-col :xs="11" :sm="11" :md="11" :lg="11">
                          <el-date-picker
                            size="small"
                            :clearable="true"
                            :editable="false"
                            v-model="item.field_value__start__"
                          ></el-date-picker>
                        </el-col>
                        <el-col :xs="2" :sm="2" :md="2" :lg="2">
                          <div style="text-align: center">to</div>
                        </el-col>
                        <el-col :xs="11" :sm="11" :md="11" :lg="11">
                          <el-date-picker
                            size="small"
                            :clearable="true"
                            :editable="false"
                            v-model="item.field_value__end__"
                          ></el-date-picker>
                        </el-col>
                      </el-row>
                    </el-form-item>

                    <!-- DATE TIME RANGE -->
                    <el-form-item
                      v-if="item.form_field_query_type === formType.DATE_TIME_RANGE"
                      :label="item.view_field_label"
                    >
                      <el-row :gutter="10">
                        <el-col :xs="11" :sm="11" :md="11" :lg="11">
                          <el-date-picker
                            type="datetime"
                            size="small"
                            :clearable="true"
                            :editable="false"
                            v-model="item.field_value__start__"
                          ></el-date-picker>
                        </el-col>
                        <el-col :xs="2" :sm="2" :md="2" :lg="2">
                          <div style="text-align: center">to</div>
                        </el-col>
                        <el-col :xs="11" :sm="11" :md="11" :lg="11">
                          <el-date-picker
                            type="datetime"
                            size="small"
                            :clearable="true"
                            :editable="false"
                            v-model="item.field_value__end__"
                          ></el-date-picker>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </template>
                </el-col>

                <el-col :xs="12" :sm="8" :md="6" :lg="4" v-else>
                  <!--<template v-if="typeCode=='bpm-setting'">-->
                  <!--<settingSelect :index="index" :formList="formList[0]"-->
                  <!--:view_field_label="item.view_field_label"></settingSelect>-->
                  <!--</template>-->

                  <template>
                    <el-form-item
                      v-if="item.form_field_query_type === formType.SINGLE_CHOICE_LIST_R1"
                      :label="item.view_field_label"
                    >
                      <el-select v-model="item.field_value" size="small">
                        <template v-for="(option, optIdx) in item.field_optional_value_list">
                          <el-option :label="option.option_label" :value="option.option_value"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <!--下拉列表单选-->
                    <el-form-item
                      v-if="item.form_field_query_type === formType.SINGLE_CHOICE_LIST"
                      :label="item.view_field_label"
                    >
                      <el-select
                        v-model="item.field_value"
                        size="small"
                        :clearable="true"
                        @change="singleSelectorChange(item.db_field_name, item.field_value, item)"
                      >
                        <template v-for="(option, optIdx) in item.field_optional_value_list">
                          <el-option :label="option.option_label" :value="option.option_value"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      v-if="item.form_field_query_type === formType.MULTIPLE_CHOICE_LIST ||  item.form_field_query_type === formType.NULL_VALUE  || item.form_field_query_type === formType.EMPTY_VALUE"
                      :label="item.view_field_label"
                      ref="ticketTypeClassname"
                    >
                      <template>
                        <el-select
                          v-model="item.field_value"
                          size="small"
                          :multiple="true"
                          :clearable="true"
                          class="ticketTypeClassname"
                          :collapse-tags="collapseTags"
                          filterable
                          @change="selectorChange(item.db_field_name, item.field_value)"
                          v-if="true"
                          style
                        >
                          <!--多选加个multiple,添加filterable和allow允许显示多选的标签-->
                          <template v-for="(option, optIdx) in item.field_optional_value_list">
                            <el-option
                              :label="option.option_label"
                              :title="option.option_label"
                              :value="option.option_value"
                            ></el-option>
                          </template>
                        </el-select>
                      </template>
                    </el-form-item>
                    <!--下拉列表多选-->
                    <el-form-item
                      v-if="item.form_field_query_type === formType.RADIOBOX_CHOICE"
                      :label="item.view_field_label"
                    >
                      <el-radio-group v-model="item.field_value" size="small">
                        <el-radio :label="option"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <!--下拉列表级联-->
                    <el-form-item
                      v-if="item.form_field_query_type === formType.CASCADER_CHOICE_LIST"
                      :label="item.view_field_label"
                    >
                      <el-cascader
                        v-model="item.field_value"
                        size="small"
                        :clearable="true"
                        :props="{ checkStrictly: true }"
                        :options="cascaderSelector[item.db_field_name]"
                        @change="cascaderSelectorChange(item.db_field_name, item.field_value)"
                      >
                      </el-cascader>
                    </el-form-item>
                    <!--RADIOBOX单选-->

                    <el-form-item
                      v-if="item.form_field_query_type === formType.CHECKBOX_CHOICE"
                      :label="item.view_field_label"
                    >
                      <el-checkbox-group v-model="item.field_value" size="small">
                        <template v-for="(option, optIdx) in item.field_optional_value_list">
                          <el-checkbox :label="option" name="type"></el-checkbox>
                        </template>
                      </el-checkbox-group>
                    </el-form-item>
                    <!--CHECKBOX多选-->

                    <el-form-item
                      v-if="item.form_field_query_type === formType.FUZZY_MATCHING_TEXT"
                      :label="item.view_field_label"
                      prop="field_value"
                    >
                      <!--prop校验-->
                      <el-input v-model="item.field_value" size="small"></el-input>
                    </el-form-item>

                    <!-- 代理相关 使用定制化结构树 -->
                    <template v-if="item.form_field_query_type === formType.EXACT_MATCHING_TEXT">
                      <template v-if="['allTree', 'tree'].includes(inputType(item.db_field_name))">
                        <el-form-item
                          :label="item.view_field_label"
                          prop="field_value"
                        >
                          <organizationTree
                            ref="pohOrgTree"
                            :check-strictly="inputType(item.db_field_name) === 'allTree'"
                            :data="item.field_tree_data"
                            :multiple="true"
                            @setinputVal="(label, value) => setTreeVal(label, value, item)"
                          />
                        </el-form-item>
                      </template>
                      <!-- 当前代理人账号 -->
                      <template v-else-if="['select'].includes(inputType(item.db_field_name))">
                        <el-form-item
                          :label="item.view_field_label"
                          prop="field_value"
                        >
                          <el-select v-model="item.field_value" size="small" @change="(value) => changeDelegation(value, item)">
                              <el-option
                                v-for="(option, optIdx) in item.field_optional_value_list"
                                :label="option.option_label"
                                :value="option.option_value"
                                :key="optIdx"
                              >
                              </el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                      <template v-else>
                        <el-form-item
                          :label="item.view_field_label"
                          prop="field_value"
                        >
                          <!--prop校验-->
                          <el-input v-model="item.field_value" size="small"></el-input>
                        </el-form-item>
                      </template>
                    </template>

                    <el-form-item
                      v-if="item.form_field_query_type === formType.SINGLE_DATE"
                      :label="item.view_field_label"
                    >
                      <el-date-picker
                        size="small"
                        :clearable="false"
                        :editable="false"
                        v-model="item.field_value"
                      ></el-date-picker>
                    </el-form-item>

                    <el-form-item
                      v-if="item.form_field_query_type === formType.SINGLE_DATETIME"
                      :label="item.view_field_label"
                    >
                      <el-date-picker
                        type="datetime"
                        size="small"
                        :clearable="false"
                        :editable="false"
                        v-model="item.field_value"
                      ></el-date-picker>
                    </el-form-item>

                    <!-- DATE TIME RANGE -->
                    <el-form-item
                      v-if="item.form_field_query_type === formType.NUMBER_RANGE"
                      :label="item.view_field_label"
                    >
                      <el-row :gutter="10">
                        <el-col :xs="11" :sm="11" :md="11" :lg="11">
                          <el-input
                            v-model="item.field_value__start__"
                            size="small"
                            onkeypress="return(/[-|.|\d]/.test(String.fromCharCode(event.keyCode)))"
                            type="number"
                          ></el-input>
                        </el-col>
                        <el-col :xs="2" :sm="2" :md="2" :lg="2">
                          <div style="text-align: center">to</div>
                        </el-col>
                        <el-col :xs="11" :sm="11" :md="11" :lg="11">
                          <el-input
                            v-model="item.field_value__end__"
                            size="small"
                            onkeypress="return(/[-|.|\d]/.test(String.fromCharCode(event.keyCode)))"
                            type="number"
                          ></el-input>
                        </el-col>
                      </el-row>
                    </el-form-item>
                    <!-- 数字输入框 -->
                    <el-form-item
                      v-if="item.form_field_query_type === formType.NUMBER"
                      :label="item.view_field_label"
                      prop="field_value"
                    >
                      <!--prop校验-->
                      <el-input v-model="item.field_value" size="small" type="number"></el-input>
                    </el-form-item>
                  </template>
                </el-col>
              </div>
              <!--操作类-->
              <el-col :span="formRemainingPlace" v-if="MoreAndSearchClickView">
                <el-form-item>
                  <div class="search-reset">
                    <el-button type="info" size="mini" @click="handleResetForm()">
                      <i class="el-icon-brush" aria-hidden="true"></i>
                      Reset
                    </el-button>
                    <el-button type="primary" size="mini" @click="handleQuery">
                      <i class="el-icon-search" aria-hidden="true"></i>
                      Search
                    </el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 在banner-master-控制是否展开的功能，以及字段模糊搜索的功能，
        目前使用页面 mytodolist,storebannermapping,中的特殊样式-->
        <div v-if="ControlMoreSeachType" style="margin-top: 25px;">
          <el-row>
            <el-col :xs="4" :sm="4" :md="4" :lg="4">
              <el-select placeholder="选择查找范围..." v-model="search_select" size="small">
                <template v-if="searchSetting">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="(item, index) in searchSettingList"
                    :key="index"
                  ></el-option>
                </template>
                <template v-else>
                  <el-option
                    :label="item.view_field_label"
                    :value="item.view_field_label"
                    v-for="(item, index) in pageSettingData_form"
                    :key="index"
                  ></el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :xs="12" :sm="13" :md="14" :lg="14">
              <el-input
                style="margin-left:20px;"
                placeholder="关键字搜索"
                size="small"
                v-model="search_select_query_params"
              ></el-input>
            </el-col>
            <el-col :xs="8" :sm="7" :md="6" :lg="6">
              <el-row>
                <div style="float: right;height: 32px;line-height: 32px;">
                  <el-button type="primary" size="mini" @click="handleQuery">
                    <i class="fa fa-search" aria-hidden="true"></i>Search
                  </el-button>
                  <el-button type="primary" size="mini" @click="handleResetForm()">
                    <i class="fa fa-eraser" aria-hidden="true"></i>
                    Reset
                  </el-button>
                </div>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="data-region">
      <div class="tool-bar">
        <el-row :gutter="10" v-if="ExchangeToolbarButtonPosition">
          <el-col :span="18">
            <div class="adapt-top adapt-bottom" style="text-align: left">
              <el-button
                @click="handleGeneralButtonClick('Import')"
                v-if="showImportButton"
                type="success"
                size="mini"
                :loading="loadingImport"
              >
                <i class="fa fa-upload" aria-hidden="true"></i>
                Import
              </el-button>
              <!-- 此处用来添加一个Hover视图 -->
              <el-tooltip
                v-for="(button, index) in toolbarButtonList"
                :key="index"
                :content="button.hoverTip"
                :disabled="button.hoverTip ? false : true"
                placement="bottom"
              >
                <el-button
                  v-if="showToolbarButtonList"
                  size="mini"
                  :type="button.type"
                  :icon="button.icon"
                  :loading="button.loading"
                  @click="handleGeneralButtonClick(button.name)"
                >{{button.label}}</el-button>
              </el-tooltip>

              <el-button
                v-if="showDeleteButton"
                type="danger"
                size="mini"
                @click="handleRemoveItem"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
                Delete
              </el-button>
              <el-button
                v-if="showExportButton && loadingDownload === false&&exportButtonLeft"
                type="primary"
                size="mini"
                @click="handleExport"
              >
                <i class="fa fa-download"></i> Export
              </el-button>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="adapt-top adapt-bottom" style="text-align: right">
              <el-popover
                @hide="saveSelectColumns"
                v-if="showSelectColumn"
                placement="bottom-start"
                class="cls-ques"
                trigger="click"
              >
                <el-button slot="reference" type="primary" size="mini">Select Columns</el-button>
                <el-tree
                  class="tabright"
                  :data="allColumns"
                  show-checkbox
                  node-key="db_field_name"
                  ref="scTree"
                  :default-expanded-keys="['all']"
                  :props="selectColumnProps"
                  @check="refreshTable"
                ></el-tree>
              </el-popover>

              <el-button
                v-if="loadingDownload && showExportButton"
                type="primary"
                size="mini"
                @click="handleExport"
                :disabled="true"
                :loading="true"
              >Downloading</el-button>
              <el-button
                v-if="showExportButton && loadingDownload === false&&!exportButtonLeft"
                type="primary"
                size="mini"
                @click="handleExport"
              >
                <i class="fa fa-download"></i> Export
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-else>
          <el-col :span="6">
            <div class="adapt-top adapt-bottom" style="text-align: left">
              <el-popover
                @hide="saveSelectColumns"
                v-if="showSelectColumn"
                placement="bottom-start"
                class="cls-ques"
                trigger="click"
              >
                <el-button slot="reference" type="primary" size="mini">Select Columns</el-button>
                <el-tree
                  class="tabright"
                  :data="allColumns"
                  show-checkbox
                  node-key="db_field_name"
                  ref="scTree"
                  :default-expanded-keys="['all']"
                  :props="selectColumnProps"
                  @check="refreshTable"
                ></el-tree>
              </el-popover>

              <el-button
                v-if="loadingDownload && showExportButton"
                type="primary"
                size="mini"
                @click="handleExport"
                :disabled="true"
                :loading="true"
              >Downloading</el-button>
              <el-button
                v-if="showExportButton && loadingDownload === false"
                type="primary"
                size="mini"
                @click="handleExport"
              >
                <i class="fa fa-download"></i> Export
              </el-button>
            </div>
          </el-col>
          <el-col :span="18">
            <div class="adapt-top adapt-bottom" style="text-align: right">
              <el-button
                v-if="showToolbarButtonList"
                v-for="(button, index) in toolbarButtonList"
                :key="index"
                size="mini"
                :type="button.type"
                :icon="button.icon"
                @click="handleGeneralButtonClick(button.name)"
              >{{button.label}}</el-button>
              <el-button
                v-if="showDeleteButton"
                type="danger"
                size="mini"
                @click="handleRemoveItem"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
                Delete
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="options.showImportDetail">
          <div class="text" style="text-align:left;padding:0 5px 10px 5px;">
            <span style="margin-right:20px;">{{options.importDetail.file_name}}</span>
            <span style="color:#409EFF;cursor:pointer" @click="showImportDetail">detail</span>
          </div>
        </el-row>
      </div>

      <div v-if="toolbarPlaceholder.length > 0">
        <h5 v-for="(content, index) in toolbarPlaceholder">{{content}}</h5>
      </div>

      <div
        class="table"
        v-loading="tableDataLoading"
        :element-loading-text="loadingPrompt"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-table
          ref="basicFormTable"
          :data="tableData"
          border
          :highlight-current-row="showHlightCurrentRow"
          :row-class-name="tableRowClassName"
          @row-click="tableRowClick"
          @select="handleSelect"
          @select-all="handleSelectAll"
        >
          <template slot="empty">Empty Content</template>
          <template v-if="showTableSelection">
            <el-table-column type="selection" width="46" v-if="!needMoreTableHead"></el-table-column>
            <el-table-column v-else>
              <el-table-column type="selection" width="46"></el-table-column>
            </el-table-column>
          </template>
          <el-table-column
            label="Operation"
            fixed="right"
            :width="definitionTableButtonWidth"
            v-if="showTableOperationButton"
          >
            <template slot-scope="scope">
              <el-button
                v-for="(buttionItem, index) in tableOperationButtonList"
                :key="index"
                :type="buttionItem.type"
                @click.stop="handleTableDefinitionButtonClick(scope.row, buttionItem.name)"
                size="mini"
                :disabled="buttionItem.needDisabled ? getStatus(scope.row) : (scope.row[buttionItem.name] == null ? false : scope.row[buttionItem.name].disabled)"
                :loading="scope.row[buttionItem.name] == null ? false : scope.row[buttionItem.name].loading"
              >{{buttionItem.label}}</el-button>
            </template>
          </el-table-column>

          <template v-if="!needMoreTableHead">
            <template v-for="(table, childIdx) in pageSettingData.table">
              <el-table-column
                :key="table.db_field_name"
                :label="table.view_field_label"
                :min-width="table.table_field_column_width"
                v-if="isIncludetableCellDataLinkField(table.db_field_name)"
              >
                <template slot-scope="scope">
                  <template v-if="showPictrueLink(scope.row, table.db_field_name)">
                    <span v-if="isPictrueUrl(scope.row[table.db_field_name])">
                      <i class="el-icon-picture view-pic" @click.stop="openImageDia(scope.row[table.db_field_name], scope)"></i>
                    </span>
                    <span v-else>
                      {{scope.row[table.db_field_name] }}
                    </span>
                  </template>
                  <template v-else>
                    <a
                      class="cell-value"
                      @click.stop="handleCustomtableCellDataLink(scope.row, table.db_field_name)"
                    >
                      {{
                      scope.row[table.db_field_name] }}
                    </a>
                  </template>

                </template>
              </el-table-column>
              <el-table-column
                v-else
                :key="table.db_field_name"
                :label="table.view_field_label"
                :min-width="table.table_field_column_width"
                :prop="table.db_field_name"
              ></el-table-column>
            </template>
          </template>

          <template v-else>
            <template v-for="(val,ind) in tableHeadConfig.splitTime">
              <el-table-column :key="ind" :label="tableHeadConfig.headNameList[ind]" align="center">
                  <template v-for="(table, childIdx) in pageSettingData.table.slice(ind==0?0:tableHeadConfig.splitIndex,ind==0?tableHeadConfig.splitIndex:pageSettingData.table.length)">
                    <el-table-column
                      :label="table.view_field_label"
                      :min-width="table.table_field_column_width"
                      v-if="isIncludetableCellDataLinkField(table.db_field_name)">
                          <template slot-scope="scope">
                            <template v-if="showPictrueLink(scope.row, table.db_field_name)">
                              <span v-if="isPictrueUrl(scope.row[table.db_field_name])">
                                <i class="el-icon-picture view-pic"></i>
                              </span>
                              <span v-else>
                                {{scope.row[table.db_field_name] }}
                              </span>
                            </template>
                            <template v-else>
                              <a
                                class="cell-value"
                                @click.stop="handleCustomtableCellDataLink(scope.row, table.db_field_name)"
                              >
                                {{
                                scope.row[table.db_field_name] }}
                              </a>
                            </template>

                          </template>
                    </el-table-column>
                    <el-table-column
                      v-else
                      :label="table.view_field_label"
                      :min-width="table.table_field_column_width"
                      :prop="table.db_field_name"
                    ></el-table-column>
                  </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </div>

      <div class="tool-bar" style="width: 100%;text-align: right" v-if="showPagination">
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalRecord"
          ></el-pagination>
        </div>
      </div>
      <!-- 图片预览弹窗 -->
      <dialog-com
        v-if="imageShowVisible"
        title=""
        width="700px"
        @handleClose="imageShowVisible=false"
        :clickToClose="false"
        :closeOnPressEscape="false"
      >
        <!-- 弹窗题 -->
        <div slot="body">
          <p>
            {{showImageListTitle}}
            <span style="color:red">
              共 {{showImageList.length}} 张
            </span>
          </p>
          <div >
            <!-- 图片展示 -->
            <div
              v-for="(item, index) in showImageList"
              :key="item"
              style="margin: 0 15px 15px 0;display: inline-block;vertical-align: bottom;"
            >
              <el-image
                class="avatar"
                :z-index="99999"
                :src="item"
                @click="previewImg(showImageList, index)"
              >
              </el-image>
            </div>
          </div>
        </div>
        <!-- 弹窗底部 -->
        <div slot="footer" style="text-align: center; padding-top: 10px">
          <el-button @click="imageShowVisible=false" type="primary" size="small">
            关闭
          </el-button>
        </div>
      </dialog-com>
    </div>
  </div>
</template>

<script>
import d1FunctionJsModule from "./d1FunctionJsModule.js";
import util from "@/util/util.js";
import { getDelegationsByUser } from "@/view/POH/util/util";
import { cloneDeep, uniq } from "lodash";
import settingSelect from "../bpm_setting/setting_select";
import dialogCom from "../dialog-com";
import organizationTree from "@/components/d1/organizationTree";

export default {
  props: {
    whetherNeedPropPageTableType: {
      type: Boolean,
      required: false,
      default: () => false
    },
    myToDoListTicketTypeStyleJudge: {
      type: Boolean,
      required: false,
      default: () => false
    },
    MyToDoListMutiple: {
      //这里控制mytodolist框的特殊的多选框选项
      type: Boolean,
      required: false,
      default: () => true
    },
    pageBannerSelected: {
      //该值用于判断是否是由用户点击进入界面后,获取url的page参数,从而控制TicketType的默认选中项,默认可以不传递
      type: Boolean,
      required: false,
      default: () => false
    },
    selectControlView: {
      type: Boolean,
      required: false,
      default: () => true
    },
    MoreAndSearchClickView: {
      //控制原样式的操作类more和search按钮的显示，默认显示
      type: Boolean,
      required: false,
      default: () => true
    },
    CategorySelectionControlMyDefault: {
      //控制原有搜索样式的显示情况，默认显示
      type: Boolean,
      required: false,
      default: () => true
    },
    ControlMoreSeachType: {
      //控制ALL关键字搜索功能的显示情况，默认不显示
      type: Boolean,
      required: false,
      default: () => false
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    dataFacetKey: {
      type: String,
      required: true,
      default: () => ""
    },
    typeCode: {
      type: String,
      required: false,
      default: () => ""
    },
    d1CoreBaseUrl: {
      type: String,
      required: true,
      default: () => ""
    },
    d1ClientBaseUrl: {
      type: String,
      required: false,
      default: () => ""
    },
    showPohFuzzyQuery: {
      type: Boolean,
      required: false,
      default: false
    },
    // 导出按钮放左边
    exportButtonLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    searchSetting: {
      type: Boolean,
      required: false,
      default: false
    },
    searchSettingList: {
      type: Array,
      required: false,
      default: () => []
    },
    searchSettingDefault: {
      type: String,
      required: false,
      default: ""
    },
  },
  components: {
    settingSelect,
    dialogCom,
    organizationTree, // poh 组织架构树
  },
  data() {
    return {
      poh_fuzzy_query: null, // POH 模糊查询
      DevisionMarketRdNamedata: "",
      collapseTags: true, //该属性控制页面多选框的形式 默认以数字的形式展示多选的数目 但是用户根据指引进入的话 需要让已经选中的项让用户知道 所以得展示完全

      CategorySelectionControlMyDefaultDataProp: true, //与more按钮的功能有关
      renderSearchView: true,
      search_select: "",
      search_select_query_params: "",
      CategorySelectionControl: false,
      formList: [],
      activeNames: [],
      getDivisionMarketRdNameUrl:
        "/dms/store-banner-mapping/getDivisionMarketRdName", //DivisionMarketRdName下拉列表的数据链接
      queryUrl: "", //查询url
      exportUrl: "", //导出url
      deleteUrl: "", //删除url
      uploadUrl: "", //上传url
      formTableUrl: "/d1/query-suite/form-table-setting",
      formType: {
        /** 日期范围选择 */
        DATE_RANGE: "DATE_RANGE",
        SINGLE_DATE: "SINGLE_DATE",
        DATE_TIME_RANGE: "DATE_TIME_RANGE",
        /** 下拉列表单选 */
        SINGLE_CHOICE_LIST_R1: "SINGLE_CHOICE_LIST_R1",
        /** 下拉列表多选 */
        MULTIPLE_CHOICE_LIST: "MULTIPLE_CHOICE_LIST",
        /** RADIOBOX单选 */
        RADIOBOX_CHOICE: "RADIOBOX_CHOICE",
        /** CHECKBOX多选 */
        CHECKBOX_CHOICE: "CHECKBOX_CHOICE",
        /**数字控制*/
        NUMBER: "NUMBER",
        /** 字符串输入 */
        TEXT: "TEXT",
        SWITCH: "SWITCH",
        NUMBER_RANGE: "NUMBER_RANGE",
        NULL_VALUE: "NULL_VALUE",
        EMPTY_VALUE: "EMPTY_VALUE",
        SEGMENTATION_TEXT: "SEGMENTATION_TEXT",
        AUTO_COMPLETE: "AUTO_COMPLETE",
        SINGLE_CHOICE_LIST: "SINGLE_CHOICE_LIST",
        SINGLE_DATETIME: "SINGLE_DATETIME",
        EXACT_MATCHING_TEXT: "EXACT_MATCHING_TEXT",
        FUZZY_MATCHING_TEXT: "FUZZY_MATCHING_TEXT",
        CASCADER_CHOICE_LIST: "CASCADER_CHOICE_LIST"
      },
      showUploadButton: false, //显示上传按钮
      showExportButton: false, //显示导出按钮
      showImportButton: false, //显示import按钮
      ExchangeToolbarButtonPosition: false, //互换 工具栏按钮位置
      showDeleteButton: false, //显示删除按钮
      showForm: true, //显示form
      showTableSelection: false, //显示表格checkbox
      showTableOperationButton: false, //显示表格操作列按钮
      needMoreTableHead:false, //显示二级表头
      tableHeadConfig:{},   //二级表头配置
      showToolbarButtonList: false, //显示工具栏按钮
      loadTableDataAfterLoadFormTableAtOnce: true,
      tableOperationButtonList: [
        {
          label: "", //按钮显示的名称
          type: "", //按钮的类型,默认空,支持  primary，success，info，warning，danger
          name: "", // 用户点击时返回的组件
          disabled: false,
          loading: false
        }
      ],
      toolbarButtonList: [
        {
          label: "", //按钮显示的名称
          type: "", //按钮的类型,默认空,支持  primary，success，info，warning，danger
          name: "", // 用户点击时返回的组件
          icon: "",
          elColWidth: 2 //按钮的占位
        }
      ],
      loadFormTableOnCreate: true, //是否初始化完成以后立即加载form
      openform: false, //是否展开form区域
      showDownloadButton: false,
      toolbarPlaceholder: [], //界面显示描述
      asyncExport: false, //是否异步导出
      dataLoading: false,
      loadingImport: false, //import按钮的loading
      confirmToRemoveDialogVisible: false,
      confirmToExportDialogVisible: false,
      editDialogVisible: false,
      totalRecord: 0,
      pageSize: 10,
      selection: [],
      currentPage: 1,
      tableData: [{}],

      pageSettingData: {
        form: [{}],
        table: [{}]
      },
      pageSettingData_form: [],
      loadingDownload: false,
      specialParam: {},
      // uploadUrl: this.baseSSO.upload_file_url,
      formData: {},
      pageSettingDataFormClone: {},
      showHlightCurrentRow: false,
      showSelectColumn: false,
      pageTableType: "",
      showPagination: true,
      confirmToAnalyzeDialogVisible: false,
      tableDataFormatter: false,
      tableDataLoading: false,
      loadingPrompt: "",
      tableCellDataLink: {}, //表格数据定义的点击事件,详细格式参照tableCellDataLinksDemo
      tableCellDataLinksDemo: {
        needCustomProcess: false, //如果设置为ture,请监听handleTableValueClick函数
        fieldProperty: [
          {
            db_field_name: "", //需要增加a标签的字段名
            field_value: [""], //a标签显示的限制值
            dialogDisplaysValueFromFields: "" // 对话框的说明来源于字段
          }
        ]
      },
      tableDataCustomerVisible: false,
      tableDataCustomerDetails: "",
      sortArr: [],
      basicCascadeInform: {},
      fieldNameCascade: {},
      // specialFormTypeChoiceNullOrEmpty: {
      //   optionalValue: '__SPECIAL_FORM_TYPE_CHOICE_NULL_OR_EMPTY__',
      //   optionalLabel: 'Null Or Empty'
      // },
      tableDataConvvert: {},
      allColumns: [],
      initFields: [],
      selectFields: [],
      moreOperationAfterQuery: false,
      selectColumnProps: { label: "view_field_label" },
      showWordTip: false,
      wordTip: "Default tip",
      queryParam: "",
      ticketTypeList: [],
      showImageList: [], // 展示图片的列表
      imageShowVisible: false, // 图片展示列表的弹窗
      showImageListTitle: "", // 图片展示列表的弹窗标题
      businessOrgTree: [], // poh 业务结构树
      delegationOrgTree: [], // poh 代理结构树
      cascaderSelector: {}, //级联下拉框的数据
      pageSettingDataForm: []
    };
  },
  computed: {
    // 是否展示ticket 的提示语
    showTicketMark() {
      let flag =  this.activeNames == "1" && ["mytodolist_store_banner_mapping", "mytodolist_banner_mgmt"].includes(this.dataFacetKey)
      return flag
    },
    baseUrl() {
      return this.d1ClientBaseUrl ? this.d1ClientBaseUrl : this.d1CoreBaseUrl;
    },
    fullQueryUrl() {
      let url = this.baseUrl + this.queryUrl;
      url += url.indexOf("?") !== -1 ? "&" : "?";
      url += "data_facet_key=" + this.dataFacetKey;
      url += this.pageParam;
      url += this.queryParams;
      // console.log(this.pageParam,"pageParam")
      // console.log(this.queryParam,"queryParam")

      // if (this.detailParam !== '') {
      //   url += (url.indexOf("?") !== -1) ? "&" : "?";
      //   url += this.detailParam;
      // }

      // url += this.sortParam;

      return url;
    },
    fullQueryUrlDevisionMarketRdName() {
      //getDevisionMarketRdName的数据请求
      let url = this.baseUrl + this.getDivisionMarketRdNameUrl;
      return url;
    },
    fullSelectColumnUrl() {
      let url =
        this.d1CoreBaseUrl +
        "/dms/select-colunms?page_table_type=" +
        this.pageTableType;
      return url;
    },

    fullFormTableUrl() {
      let url = this.d1CoreBaseUrl + this.formTableUrl;
      url += "?data_facet_key=" + this.dataFacetKey;
      return url;
    },
    pageParam() {
      if (this.showPagination) {
        let realQueryPage = this.currentPage - 1;
        let param = "&page=" + realQueryPage + "&size=" + this.pageSize;
        return param;
      }
      return "";
    },
    //传入的查询参数
    queryParams() {
      if (!this.queryParam) {
        return "";
      }
      let str = "";
      for (let key in this.queryParam) {
        if (this.queryParam[key]) {
          str += `&${key}=${this.queryParam[key]}`;
        }
      }
      return str;
    },
    fullDeleteUrl() {
      let url = this.deleteUrl;
      return url;
    },
    formRemainingPlace() {
      let totalPlace = 0;
      for (let i = 0; i < this.pageSettingData.form.length; i++) {
        let formItem = this.pageSettingData.form[i];
        if (formItem.form_field_query_type) {
          if (
            formItem.form_field_query_type === this.formType.DATE_TIME_RANGE ||
            formItem.form_field_query_type === this.formType.DATE_RANGE
          ) {
            totalPlace += 8;
          } else {
            totalPlace += 4;
          }
        }
      }
      return 24 - (totalPlace % 24);
    },
    fullModifyUrl() {
      return this.modifyUrl;
    },

    // sortParam(){
    //   let sortUrlParam = "";
    //   if(this.sortArr){
    //     for(var i in this.sortArr){
    //       if(this.sortArr[i].order){
    //         if(this.sortArr[i].order === 'ascending'){
    //           sortUrlParam += '&sort=' +this.sortArr[i].prop + ",asc";
    //         }else if(this.sortArr[i].order === 'descending'){
    //           sortUrlParam += '&sort=' +this.sortArr[i].prop + ",desc";
    //         }
    //       }
    //
    //     }
    //   }
    //   return sortUrlParam;
    // },
    detailParam() {
      let params = {};
      if (JSON.stringify(this.pageSettingData) !== "{}") {
        for (let i = 0; i < this.pageSettingData.form.length; i++) {
          let item = this.pageSettingData.form[i]; //每一个参数
          // 几个Range的判断
          if (item.form_field_query_type === this.formType.DATE_RANGE) {
            if (item.field_value__start__) {
              let value = this.timeFormatConvert(item.field_value__start__); //返回日期类型格式的值 输入的值 2019-06-14
              let parameterName = item.db_field_name + "__start__";
              this.setParams(params, parameterName, value);
            }
            if (item.field_value__end__) {
              let value = this.timeFormatConvert(item.field_value__end__); //返回日期类型格式的值 输入的值 2019-06-14
              let parameterName = item.db_field_name + "__end__";
              this.setParams(params, parameterName, value);
            }
          } else if (
            item.form_field_query_type === this.formType.DATE_TIME_RANGE
          ) {
            if (item.field_value__start__) {
              let value = this.dateTimeFormatConvert2(
                item.field_value__start__
              ); //返回日期类型格式的值 输入的值 2019-06-14
              let parameterName = item.db_field_name + "__start__";
              this.setParams(params, parameterName, value);
            }
            if (item.field_value__end__) {
              let value = this.dateTimeFormatConvert2(item.field_value__end__); //返回日期类型格式的值 输入的值 2019-06-14
              let parameterName = item.db_field_name + "__end__";
              this.setParams(params, parameterName, value);
            }
          } else if (
            item.form_field_query_type === this.formType.NUMBER_RANGE
          ) {
            if (item.field_value__start__) {
              let value = item.field_value__start__; //返回日期类型格式的值 输入的值 2019-06-14
              let parameterName = item.db_field_name + "__start__";
              this.setParams(params, parameterName, value);
            }
            if (item.field_value__end__) {
              let value = item.field_value__end__; //返回日期类型格式的值 输入的值 2019-06-14
              let parameterName = item.db_field_name + "__end__";
              this.setParams(params, parameterName, value);
            }
          }
          //单个时间插件
          else if (item.form_field_query_type === this.formType.SINGLE_DATE) {
            //判断form表字段中的类型
            //处理report date
            if (item.field_value) {
              let value = this.timeFormatConvert(item.field_value); //返回日期类型格式的值 输入的值 2019-06-14

              this.setParams(params, item.db_field_name, value);
            }
          } else if (
            item.form_field_query_type === this.formType.SINGLE_DATETIME
          ) {
            if (item.field_value) {
              let value = this.dateTimeFormatConvert2(item.field_value); //返回日期类型格式的值 输入的值 2019-06-14

              this.setParams(params, item.db_field_name, value);
            }
          } else if (typeof item.field_value === "object") {
            //输入类型为object
            let specialparamValues = [];
            if (item.field_value) {
              if(item.db_field_name === 'banner_region' && (this.dataFacetKey === 'estore_list' || this.dataFacetKey === 'estore_report')){ //为了满足d1能够查询estore的banner_region字段值
                this.setParams(params, item.db_field_name, `${item.field_value[0]}/${item.field_value.length > 1 ? item.field_value[1] : ''}`);
                console.log(`${item.field_value[0]}/${item.field_value.length > 1 ? item.field_value[1] : ''}`)
              } else if (item.db_field_name === 'banner_region' && this.dataFacetKey === 'estore_report1') {
                this.setParams(params, "banner_name", item.field_value[0]);
                this.setParams(params, "region_name", item.field_value[1]);
              } else{
                this.specialParam[item.db_field_name] = specialparamValues; //放入数组
                for (let j = 0; j < item.field_value.length; j++) {
                  let value = item.field_value[j]; //输入的值

                  if (value != null) {
                    // if (item.form_field_query_type === QueryFormType.DATE_RANGE) {  //输入的是双时间
                    //   value = this.timeFormatConvert(value);
                    // }

                    this.setParams(params, item.db_field_name, value);
                  }
                }
              }
            }
          } else if (typeof item.field_value === "string") {
            if (item.field_value !== "") {
              this.setParams(params, item.db_field_name, item.field_value);
            }
          }
        }
      }
      //根据用户选择来进行判断，得到所选类型，然后输入框就是所选类型的value,使用setParams方式建立参数查询
      //如果外部输入框有输入，就进行判断
      if (this.search_select_query_params.trim() !== "") {
        let that = this;
        //如果选择的不是All,那么就执行正常程序
        if (this.search_select !== "All") {
          let selected_pageSettingData = this.pageSettingData.form;
          let that = this;
          if(that.searchSetting){
            that.searchSettingList.forEach((item) => {
              if (item.value === that.search_select) {
                that.setParams(params, "search_field", item.value);
                that.setParams(
                  params,
                  "search_value",
                  that.search_select_query_params
                );
              }
            })
          } else{
            selected_pageSettingData.map(function(item, index) {
              if (item.view_field_label === that.search_select) {
                that.setParams(params, "search_field", item.db_field_name);
                that.setParams(
                  params,
                  "search_value",
                  that.search_select_query_params
                );
              }
            });
          }
          
        } else {
          //选择了all
          this.setParams(
              params,
              "search_value",
              this.search_select_query_params.toString()
            );
          //再all搜索的过程中可以将数据缓存后再通过关键字搜索;
          if(that.searchSetting){
            let arrParamTable = that.searchSettingList;
            let stack = [];
            for (let i = 0; i < arrParamTable.length; i++) {
              stack.push(arrParamTable[i].value);
            }
            let res = stack.join(",");
            // console.log(res)
            this.setParams(params, "search_field", res);
          } else{
            
            let arrParamTable = this.pageSettingData.table;
            let stack = [];
            for (let i = 0; i < arrParamTable.length; i++) {
              stack.push(arrParamTable[i].db_field_name);
            }
            let res = stack.join(",");
            // console.log(res)
            this.setParams(params, "search_field", res);
          }
        }
        // console.log(this.pageSettingData,6666)
        // console.log(params,"params")
        //for(let key in params){
        // if(typeof params[key]=="object"){
        //  for(let i = 0;i<this.pageSettingData.form.length;i++){
        //   if(this.pageSettingData.form[i].db_field_name==key){
        //    let fileviewWarning = this.pageSettingData.form[i].view_field_label
        //   this.$message.warning(fileviewWarning+"数据重复,请重新输入!")
        //刷新功能,或则直接不发送请求
        //  return
        // console.log(this.pageSettingData.form[i].view_field_label,999999)
        //   }
        // }
        //  }
        // }
        //找到重复数据

        //console.log(params,"params")
      } else {
        if(this.searchSetting){
          this.searchSettingList.forEach((item) => {
              if (item.value === this.search_select) {
                this.setParams(params, "search_field", item.value);
              }
            })
          }
      }
      //在此处初始化页面中的参数
      //console.log(this.pageSettingData,222222222)
      // console.log(this.MyToDoListMutiple)
      let that = this;
      //获取页面的参数,从而决定是否使用从home页面默认查询的方式
      let mutipleParams = this.$route.query.page;
      if (mutipleParams) {
        //初次根据指引进入页面,显示完整的多选项
        that.collapseTags = true;
        //判断是否在该对应使用页面使用多选框
        if (this.MyToDoListMutiple === true) {
          //更具进入页面的参数,实现页面初始的显示情况
          if (mutipleParams == "bannerManagementPage") {
            let pageSettingDataFormArr = this.pageSettingData.form;
            let that = this;
            //该函数使用的是传参的方式进行模糊搜索功能,
            //四个参数.一个vue实例,一个pageSettingData数组 ,一个参数对象params,一个默认选中项
            d1FunctionJsModule.d1FunctionJsModule_pageFuzzySearch(
              that,
              pageSettingDataFormArr,
              params,
              2
            );
          } else if (mutipleParams === "storeBannerMappingPage") {
            let that = this;
            let pageSettingDataFormArr = this.pageSettingData.form;
            d1FunctionJsModule.d1FunctionJsModule_pageFuzzySearch(
              that,
              pageSettingDataFormArr,
              params,
              1
            );
          }
        }
      }
      if(this.showPohFuzzyQuery){
        params.keyword = this.poh_fuzzy_query;
      }

      return params;
    },
    // fullFileServiceUrlForImport() {
    //   return this.uploadUrl;
    // },
    fullUrlForImport() {
      return this.uploadUrl;
    },
    exportDialogTip() {
      let tip = "";

      if (this.totalRecord === 1) {
        tip = "Confirm to export 1 record?";
      } else {
        tip = "Confirm to export " + this.totalRecord + " records?";
      }

      return tip;
    },
    fullUrlForExport() {
      let url = this.baseUrl + this.exportUrl;
      url += url.indexOf("?") !== -1 ? "&" : "?";
      url += "data_facet_key=" + this.dataFacetKey;

      let param = "";

      if (param !== "") {
        url += url.indexOf("?") !== -1 ? "&" : "?";
        url = url + param;
      }

      return url;
    },
    definitionTableButtonWidth() {
      let width = 0;
      if (
        this.tableOperationButtonList &&
        this.tableOperationButtonList.length > 0
      ) {
        for (let i = 0; i < this.tableOperationButtonList.length; i++) {
          let tableOperationWidth = this.tableOperationButtonList[i].width;
          if (tableOperationWidth) {
            width += tableOperationWidth;
          } else {
            //默认一个按钮150
            width += 150;
          }
        }
      }
      return width;
    },
    defultSelectRows() {
      if (this.tableData == null || this.tableData.length === 0) {
        return {};
      }
      return this.tableData[0];
    }
  },

  created() {
    this.initOptions(this.options);
  },
  methods: {
    MoreClickEvent() {
      d1FunctionJsModule.d1FunctionJsModule_console();
      //此处查看页面所具有的page值。从而得到
      this.$emit("listenCategorySelectionControlMyDefault", "data");
      let pageparams = this.$route.query.page;
      if (this.pageBannerSelected) {
        if (pageparams) {
          //console.log(pageparams)
        }
      }
      //console.log(this.toolbarButtonList,"")
      // console.log(this.selectControlView)
      //console.log(this.search_select)
      //console.log(this.d1ClientBaseUrl,"d1ClientBaseUrl")
      //console.log(this.d1CoreBaseUrl,"d1CoreBaseUrl")
      //console.log(this.pageSettingData_form,"pageSettingData_form")
    },
    queryHttp() {
      this.http
        // .get(this.fullQueryUrl, this.detailParam)
        ._get(this.fullQueryUrl, this.detailParam)
        .then(resp => {
          let data = resp.data;
          //一下三种dataFacetKey需要额外赋值某些字段
          // banner mgmt
          if (this.dataFacetKey == "mytodolist_banner_mgmt") {
            data.content.map(item => {
              if (item.change_content) {
                item.after_banner_type = JSON.parse(
                  item.change_content
                ).afterBannerType;
                item.before_banner_type = JSON.parse(
                  item.change_content
                ).beforeBannerType;
              }
            });
          }
          //store banner mapping
          if (this.dataFacetKey == "mytodolist_store_banner_mapping") {
            data.content.map(item => {
              if (item.change_content) {
                item.before_banner_name_cn = JSON.parse(
                  item.change_content
                ).beforeBannerName;
                item.before_banner_type = JSON.parse(
                  item.change_content
                ).beforeBannerType;
                item.after_banner_name_cn = JSON.parse(
                  item.change_content
                ).afterBannerName;
                item.after_banner_type = JSON.parse(
                  item.change_content
                ).afterBannerType;
              }
            });
          }
          // store format change
          if (this.dataFacetKey == "mytodolist_store_format_change"||this.dataFacetKey == "mytodolist_store_format_change_detail") {
            data.content.map(item => {
              if (item.change_content) {
                item.before_store_type = JSON.parse(
                  item.change_content
                ).beforeStoreType;
                item.before_store_format = JSON.parse(
                  item.change_content
                ).beforeStoreFormat;
                item.after_store_type = JSON.parse(
                  item.change_content
                ).afterStoreType;
                item.after_store_format = JSON.parse(
                  item.change_content
                ).afterStoreFormat;
              }
            });
          }

          let tableData = data.content;
          // console.log(this.detailParam, data, tableData, "runquery");
          if (data.total_elements || data.total_elements == 0) {
            this.totalRecord = data.total_elements;
          } else if (data.totalElements) {
            this.totalRecord = data.totalElements;
          } else {
            this.totalRecord = 0;
          }

          if (tableData != null && tableData.length) {
            //有数据
            for (let i = 0; i < tableData.length; i++) {
              let item = tableData[i];

              //如果值是true  or  false 会无法显示,需要处理一下
              let itemKeys = Object.keys(item); // 转成对象
              for (let j = 0; j < itemKeys.length; j++) {
                item[itemKeys[j]] =
                  item[itemKeys[j]] == null ? "" : item[itemKeys[j]] + "";
              }
            }
          }

          if (this.moreOperationAfterQuery) {
            this.$emit("handleperationAfterQuery");
          }

          if (this.tableDataFormatter && tableData && tableData.length > 0) {
            this.$emit(
              "handleTableDataFormatter",
              tableData,
              this.componentName
            );
          } else {
            this.tableData = tableData;
          }

          if (this.showHlightCurrentRow) {
            this.$refs.basicFormTable.setCurrentRow(this.defultSelectRows);
            //this.$refs.basicFormTable.setCurrentRow(this.tableData[0]);
            this.$emit("handleTableRowClick", this.defultSelectRows);
          }
          this.dataLoading = false;
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },
    runQuery() {
      //这是传入的参数,用来判断是否是mytodolist中的tickettype的样式
      let myToDoListTicketTypeStyleJudge = this.myToDoListTicketTypeStyleJudge;
      if (myToDoListTicketTypeStyleJudge === true) {
        //无判断,纯使用元素选择器进行处理,不会出现页面交叉错误
        //从home界面进入,默认参数添加后ticketType会具有自己的样式,
        //但是默认样式造成了界面溢出的问题,
        this.$nextTick(() => {
          let that = this;
          //执行该函数，可更改mytodolistticketType的样式
          d1FunctionJsModule.d1FunctionJsModule_MyToDoListTicketTypeView();
        });
      }
      if (!this.detailParam) {
        return;
      }
      if(this.formList.length==0){
        return;
      }
      this.dataLoading = true;

      //如果是这三种key才需要做ticket type的筛选，重新拼装请求条件
      if (
        [
          "mytodolist_banner_mgmt",
          "mytodolist_store_banner_mapping",
          "mytodolist_store_format_change"
        ].includes(this.dataFacetKey)
      ) {
        let form = this.handleTicketTypeByRole(this.formList);
        //如果没有选择ticket type
        if (!this.detailParam.hasOwnProperty("ticket_type")) {
          for (let i = 0; i < form.length; i++) {
            if (form[i].view_field_label == "Ticket Type") {
              //如果这个ticket 下的ticket type没有
              if (form[i].field_optional_value_list.length == 0) {
                this.detailParam.ticket_type = "no-list";
              } else {
                //如果这个ticket 下的ticket type有，就把所有的ticket type 都放进去
                this.detailParam.ticket_type = [];
                for (
                  let j = 0;
                  j < form[i].field_optional_value_list.length;
                  j++
                ) {
                  this.detailParam.ticket_type.push(
                    form[i].field_optional_value_list[j].option_value
                  );
                }
              }
            }
          }
        }
      }
      this.queryHttp();
    },
    setParams(params, key, value) {
      console.log(params, key, value);
      if (params[key]) {
        if (params[key] instanceof Array) {
          params[key].push(value);
        } else {
          let values = [];
          values.push(params[key]);
          values.push(value);
          params[key] = values;
        }
      } else {
        params[key] = value;
      }
      return params;
    },
    // 设置 poh 树的查询值
    setTreeVal(label, value, item) {
      if (!["detail_owner", "detailer"].includes(item.db_field_name)) {
        item.field_value = uniq(label).toString();
      } else {
        item.field_value = uniq(value).toString();
      }
    },
    handleQuery() {
      //根据指引进入界面后,将页面page参数置空，防止其影响原有的参数查询，
      this.$route.query.page = "";
      this.currentPage = 1;
      // console.log(111,this.detailParam)
      // let arrdata = Object.keys(this.detailParam)
      //  if(arrdata.length == 0){
      //  this.$message.warning("无搜索数据，请选择!")
      //   return
      //}

      //console.log(this.fullQueryUrl,"fullQueryUrl")
      //console.log(this.detailParam,"detailParam")
      this.runQuery();
    },
    handleResetForm() {
      let pageSettingDataFormCloneInit = util.deepClone(
        this.pageSettingDataFormClone
      );
      this.pageSettingData.form = pageSettingDataFormCloneInit;
      this.search_select_query_params = "";
      this.poh_fuzzy_query = null; // 重置 POH 的模糊查询
      if (this.$refs.pohOrgTree) {
        for (let index = 0; index < this.$refs.pohOrgTree.length; index++) {
          this.$refs.pohOrgTree[index].clearInput(); // 清空 poh 组织架构树
        }
      }
      this.currentPage = 1;
      if ( ["mytodolist_banner_mgmt", "mytodolist_store_banner_mapping", "mytodolist_store_format_change","poh_mytodolist"].includes(this.dataFacetKey)){
        this.pageSettingData.form = this.handleTicketTypeByRole(this.pageSettingData.form)
        // console.log(this.pageSettingData.form,'reset')
      }
      this.runQuery();
    },
    handleSuccess(response, file, fileList) {
      let url = this.fullUrlForImport + "?fileId=" + response.fileId;
      url += "&isPublic=false";
      url += "&fileName=" + file.name;

      this.http
        .post(url)
        .then(resp => {
          this.dataLoading = false;
          this.uploadErrorData = resp.data;
          let errorUnitList = this.uploadErrorData.error_unit_list;
          if (errorUnitList == null || errorUnitList.length === 0) {
            this.$message.success(
              "upload is successful,total rows:" +
                this.uploadErrorData.total_rows
            );
            this.runQuery();
          } else {
            this.exportDataErrorDialogVisible = true;
          }
        })
        .catch(error => {
          this.dataLoading = false;
          this.editDialogVisible = false;
        });
    },
    handleError(err, file, fileList) {
      this.dataLoading = false;
    },
    handleBeforeUpload(file) {
      if (file.size > 50 * 1024 * 1024) {
        this.$message.warning("file exceeds size limit");
        return false;
      }
      this.dataLoading = true;
      // return true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.runQuery();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.runQuery();
    },
    refresh() {
      this.runQuery();
    },
    handleRemoveItem() {
      if (this.isSelectionValid()) {
        this.confirmToRemoveDialogVisible = true;
      }
    },
    confirmToRemove() {
      let payload = {};
      let ids = [];
      this.dataLoading = true;

      for (var i = 0; i < this.selection.length; i++) {
        ids.push(this.selection[i].id);
      }

      payload.ids = ids;

      this.http
        .delete(this.fullDeleteUrl, payload)
        .then(resp => {
          let data = resp.data;
          this.dataLoading = false;
          this.confirmToRemoveDialogVisible = false;
          this.$message.success("Successful operation");
          this.currentPage = 1;
          this.runQuery();
        })
        .catch(error => {
          this.dataLoading = false;
          this.confirmToRemoveDialogVisible = false;
        });
    },
    handleExport() {
      //console.log(this.totalRecord)
      if (this.totalRecord === 0) {
        this.$message.warning("No record to export");
      } else if (this.totalRecord > 50 * 10000) {
        this.$message.warning(
          "系统暂时不能支持超过50W以上的数据量导出， 请分批导出或联系管理员导出"
        );
      } else {
        this.confirmToExportDialogVisible = true;
      }
    },
    handleSelect(selection, row) {
      this.$emit("getTableSelectedRows", selection);
      this.selection = selection;
    },
    handleSelectAll(selection) {
      this.$emit("getTableSelectedRows", selection);
      this.selection = selection;
    },
    isSelectionValid() {
      if (this.selection.length === 0) {
        this.$message.warning("Select record please");
        return false;
      } else {
        return true;
      }
    },
    handleExportExcel() {
      let that = this;
      this.loadingDownload = true;
      this.confirmToExportDialogVisible = false;
      let detailParam = this.detailParam;
      if (this.whetherNeedPropPageTableType) {
        detailParam.page_table_type = this.pageTableType;
      }

      this.http
        ._get(this.fullUrlForExport, detailParam)
        .then(resp => {
          this.loadingDownload = false;
          if (resp.data == null || resp.data === "") {
            this.$message.warning("No record to export");
          } else {
            //判断是否是异步导出
            if (this.asyncExport) {
              this.loadingDownload = true;
              this.loadExportSummary(resp.data, that.options.exportUrl);
            }
            // else {
            //   window.location.href = util.getFileSignature(this.loadingDownload, resp.data.fileId);
            // }
          }
        })
        .catch(error => {
          this.$message.warning("Export failed.");
          this.loadingDownload = false;
        });
    },
    continueUpload() {
      this.dataLoading = true;
      let url =
        "inventory-tsis/tsis/daily-sku/upload/save-template?user_id=" +
        this.$store.getters.getUserId +
        "&batch_id=" +
        this.uploadErrorData.batch_id;
      this.http
        .post(url)
        .then(resp => {
          this.$message.success("Successful operation");
          this.dataLoading = false;
          this.exportDataErrorDialogVisible = true;
          this.runQuery();
        })
        .catch(error => {
          this.dataLoading = false;
        });
    },
    downloadTemplate() {
      this.http
        .download(
          "../static/daily_sku_list_template.xlsx",
          "daily_sku_list_template.xlsx"
        )
        .then(resp => {});
    },
    updateQueryUrl(url, specialParam) {
      this.updateParentSpecialParam(specialParam);
      if (url != null && url !== "") {
        this.queryUrl = url;
      } else {
        console.error("Query url cannot be empty");
      }
    },
    updateParentSpecialParam(specialParam) {
      this.parentSpecialParam = {};
      if (specialParam && JSON.stringify(specialParam) !== "{}") {
        let specialParamKeys = Object.keys(specialParam);
        for (let i = 0; i < specialParamKeys.length; i++) {
          // console.info(3);
          let itemKey = specialParamKeys[i];
          this.parentSpecialParam[itemKey] = specialParam[itemKey];
        }
      }
    },
    updateExportUrl(url) {
      this.exportUrl = url;
    },
    updateQueryFormSetting(pageSettingData) {
      this.pageSettingData = pageSettingData;
    },
    calPercentage(row) {
      if (row.total_succeed_count == null) {
        return 0;
      }
      if (row.total_succeed_count == null) {
        return 0;
      }
      if (row.total_rows == null) {
        return 0;
      }
      let percentage =
        (
          (row.total_succeed_count + row.total_succeed_count) /
          row.total_rows
        ).toFixed(2) * 100;

      return percentage > 100 ? 100 : percentage;
    },
    initOptions(options) {
      //初始化组件
      this.queryUrl =
        options.queryUrl != null ? options.queryUrl : this.queryUrl; //表格的查询url
      this.importUrl =
        options.importUrl != null ? options.importUrl : this.importUrl; //导入文件的url
      this.exportUrl =
        options.exportUrl != null ? options.exportUrl : this.exportUrl; //导出文件的url
      this.uploadUrl =
        options.uploadUrl != null ? options.uploadUrl : this.uploadUrl; //导出文件的url
      this.deleteUrl =
        options.deleteUrl != null ? options.deleteUrl : this.deleteUrl; //删除功能
      this.formTableUrl =
        options.formTableUrl != undefined
          ? options.formTableUrl
          : this.formTableUrl; //表单查询
      this.tableOperationButtonList =
        options.tableOperationButtonList != null
          ? options.tableOperationButtonList
          : this.tableOperationButtonList; //表格内按钮组
      if (options.pageSize) {
        this.pageSize = options.pageSize; //可以修改默认的每页数量 默认 10
      }

      this.loadFormTableOnCreate =
        options.loadFormTableOnCreate != null
          ? options.loadFormTableOnCreate
          : this.loadFormTableOnCreate;
      this.tableDataConvvert =
        options.tableDataConvvert != null
          ? options.tableDataConvvert
          : this.tableDataConvvert;

      this.pageSettingData =
        options.pageSettingData != null
          ? options.pageSettingData
          : this.pageSettingData;
      this.showUploadButton =
        options.showUploadButton != null
          ? options.showUploadButton
          : this.showUploadButton;
      this.showTableSelection =
        options.showTableSelection != null
          ? options.showTableSelection
          : this.showTableSelection;
      this.showTableOperationButton =
        options.showTableOperationButton != null
          ? options.showTableOperationButton
          : this.showTableOperationButton;

      //需要二级表头
      this.needMoreTableHead =
        options.needMoreTableHead != null
          ? options.needMoreTableHead
          : this.needMoreTableHead;

      //二级表头的配置
      this.tableHeadConfig =
        options.tableHeadConfig != null
          ? options.tableHeadConfig
          : this.tableHeadConfig;

      this.showExportButton =
        options.showExportButton != null
          ? options.showExportButton
          : this.showExportButton;

      this.showImportButton =
        options.showImportButton != null
          ? options.showImportButton
          : this.showImportButton;


      this.ticketTypeList =
        options.ticketTypeList != null
          ? options.ticketTypeList
          : this.ticketTypeList;

      this.ExchangeToolbarButtonPosition = options.ExchangeToolbarButtonPosition
        ? true
        : false; //互换位置
      this.queryParam = options.queryParam ? options.queryParam : null; //query 接口的参数扩展
      this.showPagination =
        options.showPagination != null
          ? options.showPagination
          : this.showPagination;
      this.showSelectColumn =
        options.showSelectColumn != null
          ? options.showSelectColumn
          : this.showSelectColumn;
      this.showForm =
        options.showForm != null ? options.showForm : this.showForm;
      this.showToolbarButtonList =
        options.showToolbarButtonList != null
          ? options.showToolbarButtonList
          : this.showToolbarButtonList;
      this.tableDataFormatter =
        options.tableDataFormatter != null
          ? options.tableDataFormatter
          : this.tableDataFormatter;
      this.toolbarButtonList =
        options.toolbarButtonList != null
          ? options.toolbarButtonList
          : this.toolbarButtonList;
      this.toolbarPlaceholder =
        options.toolbarPlaceholder != null
          ? options.toolbarPlaceholder
          : this.toolbarPlaceholder;
      this.loadingPrompt =
        options.loadingPrompt != null
          ? options.loadingPrompt
          : this.loadingPrompt;
      this.tableCellDataLink =
        options.tableCellDataLink != null
          ? options.tableCellDataLink
          : this.tableCellDataLink;
      //定制服务
      this.asyncExport =
        options.asyncExport != null ? options.asyncExport : this.asyncExport; //是否异步导出
      this.loadTableDataAfterLoadFormTableAtOnce =
        options.loadTableDataAfterLoadFormTableAtOnce != null
          ? options.loadTableDataAfterLoadFormTableAtOnce
          : this.loadTableDataAfterLoadFormTableAtOnce; //加载form 后是否立即执行一次查询
      this.openform =
        options.openform != null ? options.openform : this.openform; //ETL自定义功能
      // 拷贝值，给reset使用
      //显示表格的当前行
      this.showHlightCurrentRow =
        options.showHlightCurrentRow != null
          ? options.showHlightCurrentRow
          : this.showHlightCurrentRow;
      this.selectColumnProps =
        options.selectColumnProps != null
          ? options.selectColumnProps
          : this.selectColumnProps;

      if (this.openform) {
        this.activeNames = ["1"];
      }

      if (this.loadFormTableOnCreate) {
        this.loadFormTableSetting();
      } else {
        this.pageSettingDataFormClone = util.deepClone(
          this.pageSettingData.form
        );
      }

      this.pageTableType =
        options.pageTableType != null
          ? options.pageTableType
          : this.pageTableType;
      this.moreOperationAfterQuery =
        options.moreOperationAfterQuery != null
          ? options.moreOperationAfterQuery
          : this.moreOperationAfterQuery;
      this.showWordTip =
        options.showWordTip != null ? options.showWordTip : this.showWordTip;
      this.wordTip = options.wordTip != null ? options.wordTip : this.wordTip;
    },

    handleAdd() {
      this.$emit("handleAdd");
    },
    handleEdit(row) {
      this.$emit("handleEdit", row);
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex - 1) % 2 === 0) {
        return "primary-row";
      } else {
        return "";
      }
    },
    tableRowClick(row) {
      if (this.showHlightCurrentRow) {
        this.$emit("handleTableRowClick", row);
      }
    },
    timeFormatConvert(od) {
      Date.prototype.format = function(fmt) {
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
        return fmt;
      };

      var dd = new Date(od).format("yyyy-MM-dd");
      return dd.toString();
    },
    dateTimeFormatConvert2(od) {
      Date.prototype.format = function(fmt) {
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
        return fmt;
      };

      var dd = new Date(od).format("yyyy-MM-dd hh:mm:ss");
      return dd.toString();
    },

    handleDownload(row) {
      let downloadUrl =
        "inventory-dsis/dsis/data-sources/view/ds-file-import/file-id?import_id=" +
        row.import_id;
      this.http
        .get(downloadUrl)
        .then(resp => {
          if (resp.data) {
            // util.downloadPublicOrPrivateFileByUrlOrFileId(resp.data);
            window.location.href = util.getFileSignature(
              this.dataLoading,
              resp.data
            );
          }
        })
        .catch(error => {
          this.dataLoading = false;
          console.error(error);
        });
    },
    handleRelease() {
      if (this.isSelectionValid()) {
        this.$emit("handleRelease", this.selection);
      }
    },
    handleAnalyze() {
      this.dataLoading = true;
      this.confirmToAnalyzeDialogVisible = false;
      this.http
        .post(this.analyzeUrl)
        .then(resp => {
          this.dataLoading = false;
          this.$message.success("创建分析任务成功，请稍等2分钟后查看结果");
        })
        .catch(error => {
          this.dataLoading = false;
          this.$message.warning("无法创建分析任务，请联系管理员");
        });
    },
    loadExportSummary(exportId, exportUrl) {
      let that = this;
      if (exportId <= -1) {
        that.loadingDownload = false;
        that.$message.warning("Service is busy,please try again later");
        return;
      } else {
        let summaryUrl = `${this.baseD1Url}/dms/data-export/info?id=${exportId}`; // dms 的导出
        if (exportUrl.startsWith("/poh/")) {
          // poh 的导出
          summaryUrl = `${this.baseStoreUrl}/poh/export/info?id=${exportId}`
        }

        let intervalId = setInterval(function() {
          that.http
            .get(summaryUrl)
            .then(resp => {
              let data = resp.data;
              if (data == null || data.failed_at) {
                that.$message.warning(data.details);
                that.loadingDownload = false;
                window.clearInterval(intervalId);
              } else if (data.file_id) {
                that.loadingDownload = false;
                window.clearInterval(intervalId);

                window.location.href = util.getFileSignature(
                  this.loadingDownload,
                  resp.data.file_id
                );
              }
            })
            .catch(error => {
              that.$message.warning("Export failed.");
              that.loadingDownload = false;
              window.clearInterval(intervalId);
            });
        }, 3000);
      }
    },
    handleTableDefinitionButtonClick(row, name) {
      this.$emit("onTableOperationButtonClick", row, name);
    },
    handleGeneralButtonClick(name) {
      this.$emit("onToolbarButtonClick", name);
    },
    setTableData(tableData) {
      this.tableData = tableData;
    },
    getTableData() {
      return this.tableData;
    },

    clearTableData() {
      this.tableData = [{}];
      this.totalRecord = 0;
    },
    inArray(arr, str) {
      let i = arr.length;
      while (i--) {
        if (arr[i] === str) {
          return true;
        }
      }
      return false;
    },
    setPageSettingData(pageSettingData) {
      this.pageSettingData = pageSettingData;
      this.pageSettingDataFormClone = util.deepClone(this.pageSettingData.form);
    },
    setDataLoading(status) {
      this.dataLoading = status;
    },
    showTrendChart(row) {
      this.$emit("showTrendChart", row);
    },
    handleDelete(row) {
      this.$emit("handleDelete", row);
    },
    setTableDataLoading(status) {
      this.tableDataLoading = status;
    },
    isIncludetableCellDataLinkField(fieldKey) {
      let fieldList = this.tableCellDataLink;
      if (fieldList && fieldList.length) {
        let i = fieldList.length;
        while (i--) {
          if (fieldList[i].db_field_name === fieldKey) {
            return true;
          }
        }
      }
      return false;
    },
    // 是否是预览图片的链接
    showPictrueLink(row, fieldKey) {
      let fieldList = this.tableCellDataLink;
      if (fieldList && fieldList.length) {
        let i = fieldList.length;
        while (i--) {
          if (fieldList[i].db_field_name === fieldKey) {
            if (fieldList[i].hasOwnProperty("linkType") && fieldList[i].linkType === "pictureLink") {
              return true;
            } else {
              return false;
            }
          }
        }
      }
      return false;
    },
    // 判断是否是图片链接
    isPictrueUrl(value){
      try {
        if (!["", '', null, undefined].includes(value)) {
            let flag =  value.toString();
            // debugger
            let arr = JSON.parse(flag);
            if (arr instanceof Array) {
              // 可以转换成数组
              if (arr.length && arr[0].startsWith("https://")) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
        } else {
          return false;
        }
      } catch (error) {
        console.log("不能转成图片路径, 正常显示值");
        return false;
      }
    },
    // 打开图片预览弹窗
    openImageDia(data, scope){
      try {
        this.showImageList = JSON.parse(data);
      } catch (error) {
        console.log("打开图片预览弹窗错误");
        this.showImageList = [];
      }
      let title = scope.row.type ? scope.row.type + ":" : "";
      this.showImageListTitle = `${title} ${scope.column.label}`;
      this.imageShowVisible = true;
    },
    // 查看图片
    previewImg(list, index = 0) {
      this.$PreviewPic({
        zIndex: 9000, // 组件的zIndex值 默认为2000
        index, // 展示第几张图片 默认为0
        list, // 需要展示图片list
        onClose: (i) => {
          // 关闭时的回调
          console.log(i);
        },
        onSelect: (i) => {
          // 点击某张图片的回调
          console.log(i);
        },
      });
    },
    handleCustomtableCellDataLink(row, fieldKey) {
      let fieldList = this.tableCellDataLink;
      this.$emit("handleTableValueClick", row, fieldKey);
    },
    setDataFacetKey(dataFacetKey) {
      this.dataFacetKey = dataFacetKey;
    },
    loadFormTableSetting() {
      this.dataLoading = true;
      let _this = this;
      this.http
        .get(this.fullFormTableUrl)
        .then( async (resp) => {
          let formData = cloneDeep(resp.data.form);
          let treeIdx = formData.findIndex((item, index) => {
            if (item.form_field_query_type === this.formType.EXACT_MATCHING_TEXT) {
              if (this.inputType(item.db_field_name) != "input") {
                return index;
              }
            }
          })
          let seleIdx = formData.findIndex((item, index) => {
            if (item.form_field_query_type === this.formType.EXACT_MATCHING_TEXT) {
              if (this.inputType(item.db_field_name) === "select") {
                return index;
              }
            }
          })
          let field_optional_value_list = [];
          if (treeIdx != -1) {
            if (seleIdx != -1) {
              // 获取poh 当前用户的代理信息,整合当前代理人账号下拉列表
              let delegatList = await getDelegationsByUser(true);
              delegatList.forEach(item => {
                field_optional_value_list.push({
                  option_label: item.delegated_name,
                  option_value: item.username,
                  option_role: item.delegated_role,
                })
              });
            }
            await this.getBusinessOrgTree();
            await this.queryDelegationOrgTree();
            formData.forEach(item => {
              if (item.form_field_query_type === this.formType.EXACT_MATCHING_TEXT) {
                if (this.inputType(item.db_field_name) === "tree") {
                  item.field_tree_data = this.businessOrgTree;
                } else if(this.inputType(item.db_field_name) === "allTree"){
                  item.field_tree_data = this.delegationOrgTree;
                } else if (this.inputType(item.db_field_name) === "select"){
                  item.field_optional_value_list = field_optional_value_list;
                  // 默认选定第一个代理人账号
                  item.field_value = `[\"${field_optional_value_list[0].option_value}\"]`;
                }
              }
            });
          }
          let res = cloneDeep(resp);
          res.data.form = formData;
          resp = res;
          let data = resp.data;
          let form = data.form;
          this.formList = data.form;
          // console.log(this.formList, data, "loadFormTableSetting");
          this.pageSettingData = data;
          //null or empty初始化
          let allNode = {
            "view_field_label": "All",
            "db_field_name": "all",
            "table_field_sequence": 9999999,
            "table_field_column_width": 120,
            "children": null,
            "table_field_order_by": "NONE"
          }
          allNode.children = data.table
          this.allColumns = [allNode];
          this.pageSettingData.form = this.handleDefaultVal(form);
          this.pageSettingData.form = this.handleNullOrEmpty(form);
          this.$emit('setDefaultValue', form);
          //级联初始化
          this.pageSettingData.form = this.handleCascade(form);
          this.$emit('getCascaderSelector')
          this.pageSettingDataFormClone = util.deepClone(
            this.pageSettingData.form
          );
          // TOFIXED
          this.$emit("completeLoadForm", this.pageSettingData);

          // console.log("tableColumns:" + this.showSelectColumn);
          if (!this.showSelectColumn) {
            if (this.loadTableDataAfterLoadFormTableAtOnce) {
              this.runQuery();
              // this.dataLoading = false;
            }
          } else {
            // console.log("url=====" + this.fullSelectColumnUrl);
            this.http.get(this.fullSelectColumnUrl).then(resp => {
              let columnData = resp.data;
              let table = this.pageSettingData.table;
              let realTable = [];
              if (columnData && columnData.length) {
                for (var i in table) {
                  for (var j in columnData) {
                    if (i == 0) {
                      //双重遍历，只需要第一次遍历的结果
                      this.initFields.push(columnData[j]);
                    }

                    if (columnData[j] == table[i].db_field_name) {
                      realTable.push(table[i]);
                      if (i != 0) {
                        break;
                      }
                    }
                  }
                }
                // console.log(realTable);
                this.pageSettingData.table = realTable;
              } else {
                for (var i in this.allColumns[0].children) {
                  this.initFields.push(this.allColumns[0].children[i].db_field_name);
                }
              }

              this.$refs.scTree.setCheckedKeys(this.initFields);
              // console.log(this.initFields);
              if (this.loadTableDataAfterLoadFormTableAtOnce) {
                this.runQuery();
              } else {
                this.dataLoading = false;
              }
            });
          }

          //加载完form后立即执行查询

          // this.runQuery();
          //加载完表单后，取得表单的view_field_label,然后添加一个All选项
          this.pageSettingData_form = [{ view_field_label: "All" }].concat(
            this.pageSettingData.form
          );
          //初始化选择类型
          this.search_select = this.searchSettingDefault ? this.searchSettingDefault : this.pageSettingData_form[0].view_field_label;
          //建立一个all的模糊搜索选项
          let all_search = JSON.stringify(this.pageSettingData_form[1]);
          let all_search_selected = JSON.parse(all_search);
          //设置模糊搜索的参数
          all_search_selected.view_field_label = "All";
          all_search_selected.db_field_name = "search_value";
          //将设置好的模糊搜索参数添加进入选择的队列
          this.pageSettingData_form.splice(0, 1, all_search_selected);
          //console.log(all_search_selected)
          //console.log(this.pageSettingData_form)
        })
        .catch(error => {
          console.info(error);
          this.dataLoading = false;
        });
    },
    handleCascade(form) {
      //1.提取全部的级联关系
      //2。提取默认全部选中
      //3。构建真正的级联关系
      this.basicCascadeInform = {};
      this.fieldNameCascade = {};
      let childFieldNameList = [];
      //第一轮遍历，填充默认下拉框的值，并复制基础级联结构
      for (let i = 0; i < form.length; i++) {
        let formItem = form[i];
        if (formItem.field_cascade_optional_value_list) {
          formItem.field_optional_value_list = [];
          //add null or empty
          // formItem.field_optional_value_list.push({
          //   option_label: this.specialFormTypeChoiceNullOrEmpty.optionalLabel,
          //   option_value: this.specialFormTypeChoiceNullOrEmpty.optionalValue
          // });
          this.fieldNameCascade[formItem.db_field_name] =
            formItem.field_cascade_child_field_name;
          childFieldNameList.push(formItem.field_cascade_child_field_name);
          this.basicCascadeInform[formItem.db_field_name] =
            formItem.field_cascade_optional_value_list;
          for (
            let j = 0;
            j < formItem.field_cascade_optional_value_list.length;
            j++
          ) {
            let fieldOptionValue = {};
            formItem.field_optional_value_list.push(fieldOptionValue);
            fieldOptionValue.option_label =
              formItem.field_cascade_optional_value_list[j].option_label;
            fieldOptionValue.option_value =
              formItem.field_cascade_optional_value_list[j].option_value;
          }
        }
      }
      //第二轮遍历， 取消级联关系中所有下级的数据
      for (let i = 0; i < form.length; i++) {
        let formItem = form[i];
        if (this.inArray(childFieldNameList, formItem.db_field_name)) {
          formItem.field_optional_value_list = [];
          // formItem.field_optional_value_list.push({
          //   option_label: this.specialFormTypeChoiceNullOrEmpty.optionalLabel,
          //   option_value: this.specialFormTypeChoiceNullOrEmpty.optionalValue
          // });
        }
      }
      return form;
    },
    //单选改变
    singleSelectorChange(dbFieldName, chooseValueList,item) {
      this.$emit("changeTicketType", dbFieldName, chooseValueList,item);
    },
    cascaderSelectorChange(dbFieldName, chooseValueList) {
      this.$emit("cascaderSelectorChange", dbFieldName, chooseValueList);
    },
    selectorChange(dbFieldName, chooseValueList) {
      console.log(dbFieldName, chooseValueList)
      // if(this.dataFacetKey=='ALL_MY_TO_DO_LIST'){
      //   this.$emit('changeTicketType',chooseValueList)
      // }
      // console.log(dbFieldName, chooseValueList, 33333);
      d1FunctionJsModule.d1FunctionJsModule_MyToDoListTicketTypeView();
      //人为选择的时候，还是采用原有的多选内容样式展示
      this.collapseTags = true;
      //只考虑级联的下一级
      let childFieldName = this.fieldNameCascade[dbFieldName];
      let form = this.pageSettingData.form;
      //只有存在级联关系时才需要往下继续
      if (this.basicCascadeInform[dbFieldName]) {
        for (let i = 0; i < form.length; i++) {
          let formItem = form[i];
          //仅控制这一级
          if (childFieldName === formItem.db_field_name) {
            //为这一级赋值
            formItem = this.fullChildFieldSelector(
              dbFieldName,
              chooseValueList,
              formItem.field_value,
              formItem
            );

            //还存在下级，继续往下迭代
            if (formItem.field_cascade_child_field_name) {
              this.selectorChange(formItem.db_field_name, formItem.field_value);
            }
          }
        }
      }
    },
    fullChildFieldSelector(
      parentFieldName,
      parentChooseValueList,
      childChooseValueList,
      formItem
    ) {
      let cascadeOptionsList = this.basicCascadeInform[parentFieldName];

      //添加逻辑,select组件，设置multiple为true时，parentChooseValueList是以个arr,
      //但是强制设置为false时，parentChooseValueList只是一个string,后面的inArray函数就进不去，子选项就丢失了
      //这里添加了对my to do list 这个页面的d1 key做了处理
      // let tempArr = [];
      // // if (this.dataFacetKey === "ALL_MY_TO_DO_LIST") {
      // if (this.dataFacetKey === "mytodolist_store_banner_mapping"||
      //     this.dataFacetKey === "mytodolist_store_format_change" ||
      //     this.dataFacetKey === 'mytodolist_banner_mgmt'
      // ) {
      //   tempArr.push(parentChooseValueList);
      // }

      //1.加载全部可选项
      formItem.field_optional_value_list = [];
      // formItem.field_optional_value_list.push({
      //   option_label: this.specialFormTypeChoiceNullOrEmpty.optionalLabel,
      //   option_value: this.specialFormTypeChoiceNullOrEmpty.optionalValue
      // });

      for (let i = 0; i < cascadeOptionsList.length; i++) {
        let parentOptional = cascadeOptionsList[i];
        if (this.inArray(parentChooseValueList, parentOptional.option_value)) {
          if (parentOptional.children) {
            for (let j = 0; j < parentOptional.children.length; j++) {
              formItem.field_optional_value_list.push(
                parentOptional.children[j]
              );
            }
          }
        }
      }

      //添加ALL_MY_TO_DO_LIST的判断，只有在这个页面才需要将多选改成单选
      // if (this.dataFacetKey !== "ALL_MY_TO_DO_LIST") {

      // if (this.dataFacetKey !== "mytodolist_store_banner_mapping"&&
      //     this.dataFacetKey !== "mytodolist_store_format_change"&&
      //     this.dataFacetKey !== "mytodolist_banner_mgmt") {
      //   if (
      //     this.inArray(parentChooseValueList, parentOptional.option_value)
      //   ) {
      //     if (parentOptional.children) {
      //       for (let j = 0; j < parentOptional.children.length; j++) {
      //         formItem.field_optional_value_list.push(
      //           parentOptional.children[j]
      //         );
      //       }
      //     }
      //   }
      // }
      // else {
      //   if (this.inArray(tempArr, parentOptional.option_value)) {
      //     if (parentOptional.children) {
      //       for (let j = 0; j < parentOptional.children.length; j++) {
      //         formItem.field_optional_value_list.push(
      //           parentOptional.children[j]
      //         );
      //       }
      //     }
      //   }
      // }

      //2。遍历可选项,取出可选项value list
      let optionalValueList = [];
      for (let i = 0; i < formItem.field_optional_value_list.length; i++) {
        let optionalValue = formItem.field_optional_value_list[i].option_value;
        optionalValueList.push(optionalValue);
      }
      //3. 两个数组取交集
      formItem.field_value = optionalValueList.filter(v =>
        childChooseValueList.includes(v)
      );
      return formItem;
    },
    handleNullOrEmpty(form) {
      for (let i = 0; i < form.length; i++) {
        let formItem = form[i];
        if (
          formItem.form_field_query_type ===
            this.formType.MULTIPLE_CHOICE_LIST ||
          formItem.form_field_query_type === this.formType.SINGLE_CHOICE_LIST ||
          formItem.form_field_query_type === this.formType.SINGLE_CHOICE_LIST_R1
        ) {
          if (formItem.field_optional_value_list) {
            formItem.field_optional_value_list.splice(0, 0);
            //  {
            //   option_label: this.specialFormTypeChoiceNullOrEmpty.optionalLabel,
            //   option_value: this.specialFormTypeChoiceNullOrEmpty.optionalValue
            // }
          } else {
            formItem.field_optional_value_list = [];
            // formItem.field_optional_value_list.push({
            //   option_label: this.specialFormTypeChoiceNullOrEmpty.optionalLabel,
            //   option_value: this.specialFormTypeChoiceNullOrEmpty.optionalValue
            // });
          }
        }
      }
      return form;
    },
    // 后台为json化 数组字符串
    handleDefaultVal(form) {
      for (let i = 0; i < form.length; i++) {
        let formItem = form[i];
        let fieldValue = formItem.field_value;
        if (fieldValue) {
          try {
            let fieldValArr = JSON.parse(fieldValue);
            if (fieldValArr instanceof Array) {
              if (
                formItem.form_field_query_type ==
                this.formType.MULTIPLE_CHOICE_LIST
              ) {
                formItem.field_value = fieldValArr;
              } else if (
                formItem.form_field_query_type == this.formType.DATE_RANGE ||
                formItem.form_field_query_type ==
                  this.formType.DATE_TIME_RANGE ||
                formItem.form_field_query_type == this.formType.NUMBER_RANGE
              ) {
                if (fieldValArr) {
                  if (fieldValArr[0]) {
                    formItem.field_value__start__ = fieldValArr[0];
                  }
                  if (fieldValArr[1]) {
                    formItem.field_value__end__ = fieldValArr[1];
                  }
                }
              } else {
                if (fieldValArr[0]) {
                  formItem.field_value = fieldValArr[0];
                }
              }
            } else {
              // console.log(formItem.db_field_name + ": " + formItem.field_value + " is not array");
              // 不符合格式设为''
              this.handleMisformVal(formItem);
            }
          } catch (data) {
            console.log(data);
            this.handleMisformVal(formItem);
          }
        }
      }
      return form;
    },
    handleMisformVal(formItem) {
      //这里需要添加逻辑
      if (
        formItem.form_field_query_type == this.formType.MULTIPLE_CHOICE_LIST ||
        formItem.form_field_query_type == this.formType.SINGLE_CHOICE_LIST
      ) {
        // if (formItem.form_field_query_type == this.formType.MULTIPLE_CHOICE_LIST) {

        formItem.field_value = [];
      } else {
        formItem.field_value = "";
      }
    },
    //根据角色显示请求获取到的ticket type
    handleTicketTypeByRole(form) {
      // 只保留当前这个role有的ticket type
        for (let i = 0; i < form.length; i++) {
          if (form[i].view_field_label == "Ticket Type") {
            for (let j = 0; j < form[i].field_optional_value_list.length; j++) {
              if (
                !this.ticketTypeList.includes(
                  form[i].field_optional_value_list[j].option_value
                )
              ) {
                form[i].field_optional_value_list.splice(j, 1);
                j--;
              }
            }
          }
        }

        let sbm = [
          "New Store",
          "Store Format Change-Trade Fund",
          "Store Format Change-Non Trade Fund",
          "Banner Type/Store Type Change"
        ];

        let sfc = ["Store Format Change"];

        let bm = [
          "New Banner",
          "Channel Type Change-Top banner",
          "Channel Type Change-Non top Banner",
          "Banner Basic Info Change"
        ];
        // 具有 poh 的权限
        let poh = ["Clinics/Dental Professionals"];
        let has_poh = false;

        let has_sbm = false,
          has_sfc = false,
          has_bm = false;

        for (let i = 0; i < this.ticketTypeList.length; i++) {
          if (poh.includes(this.ticketTypeList[i])) {
            has_poh = true;
          }
        }

        for (let i = 0; i < this.ticketTypeList.length; i++) {
          if (sbm.includes(this.ticketTypeList[i])) {
            has_sbm = true;
            break;
          }
        }

        for (let i = 0; i < this.ticketTypeList.length; i++) {
          if (sfc.includes(this.ticketTypeList[i])) {
            has_sfc = true;
          }
        }

        for (let i = 0; i < this.ticketTypeList.length; i++) {
          if (bm.includes(this.ticketTypeList[i])) {
            has_bm = true;
          }
        }

        //将没有ticket type的ticket 删除
        for (let i = 0; i < form.length; i++) {
          if (form[i].view_field_label == "Ticket") {
            for (let j = 0; j < form[i].field_optional_value_list.length; j++) {
              if (!has_sbm) {
                //没有store banner mapping
                if (
                  form[i].field_optional_value_list[j].option_value ==
                  "Store Banner Mapping"
                ) {
                  form[i].field_optional_value_list.splice(j, 1);
                }
              }
            }
          }
        }
        console.log(form)
        for (let i = 0; i < form.length; i++) {
          if (form[i].view_field_label == "Ticket") {
            for (let j = 0; j < form[i].field_optional_value_list.length; j++) {
              if (!has_sfc) {
                //没有Store Format Change
                if (
                  form[i].field_optional_value_list[j].option_value ==
                  "Store Format Change"
                ) {
                  form[i].field_optional_value_list.splice(j, 1);
                }
              }
            }
          }
        }

        for (let i = 0; i < form.length; i++) {
          if (form[i].view_field_label == "Ticket") {
            for (let j = 0; j < form[i].field_optional_value_list.length; j++) {
              if (!has_bm) {
                //没有Banner Management
                if (
                  form[i].field_optional_value_list[j].option_value ==
                  "Banner Management"
                ) {
                  form[i].field_optional_value_list.splice(j, 1);
                }
              }
            }
          }
        }

        // 删除 Clinics/Dental Professionals
        for (let i = 0; i < form.length; i++) {
          if (form[i].view_field_label == "Ticket") {
            for (let j = 0; j < form[i].field_optional_value_list.length; j++) {
              if (!has_poh) {
                // 没有 Clinics/Dental Professionals
                if (form[i].field_optional_value_list[j].option_value == "Clinics/Dental Professionals") {
                  form[i].field_optional_value_list.splice(j, 1);
                }
              }
            }
          }
        }
        // 重置 Ticket
        for (let i = 0; i < form.length; i++) {
          if (form[i].view_field_label == "Ticket") {
            // 不是通过菜单 或者 小卡片进入的,就重定向
            if(!this.$route.query.hasOwnProperty("name")){
              // 定制化默认跳转 
              let tickets = form[i].field_optional_value_list.map( item => item.option_value); // 所有的 Ticket 集
              // 存在POH的ticket不能设定默认值，否则导致POH无法正常使用todolist页面
              if (!tickets.includes("Clinics/Dental Professionals")) {
                let mdmIdx = form[i].field_optional_value_list.findIndex(item => item.option_value === "MDM Tickets");
                if (mdmIdx > -1) {
                  // 定制跳转 MDM Tickets
                  this.$emit('resetDataFaceKey', form[i].field_optional_value_list[mdmIdx].option_label);
                } else {
                  // 跳转第一个
                  form[i].field_value = form[i].field_optional_value_list[0].option_label;
                  this.$emit('resetDataFaceKey',form[i].field_value);
                }
              } else {
                // 跳转第一个
                form[i].field_value = form[i].field_optional_value_list[0].option_label;
                this.$emit('resetDataFaceKey',form[i].field_value);
              }
            }
          }
        }
      return form;
    },
    // 获取当前选定行
    getSelection() {
      return this.selection;
    },
    // 清空当前选定行
    clearSelectionRowData() {
      this.selection = [];
    },
    refreshTable() {
      let selectFields = this.$refs.scTree.getCheckedKeys();
      if (selectFields.length) {
        let showTableColumns = [];
        for (var i in selectFields) {
          for (var j in this.allColumns[0].children) {
            if (selectFields[i] == this.allColumns[0].children[j].db_field_name) {
              showTableColumns.push(this.allColumns[0].children[j]);
              break;
            }
          }
        }
        this.pageSettingData.table = showTableColumns;
      } else {
        this.pageSettingData.table = [];
      }
    },
    saveSelectColumns() {
      let selectFields = this.$refs.scTree.getCheckedKeys();
      let idx = selectFields.findIndex(item => item === "all");
      if (idx != -1) {
        selectFields.splice(idx,1);
      }
      let saveColumnUrl = this.d1CoreBaseUrl + "/dms/select-colunms/update";

      if (!selectFields || !selectFields.length) {
        this.$message.warning("Can not Save empty columns");
        return;
      }
      if (!this.pageTableType) {
        console.warn("没有配置pageTableType,不能进行保存");
        return;
      }

      let initFields = this.initFields;
      if (initFields.length === selectFields.length) {
        let sameFlag = true;
        for (var i in selectFields) {
          if (initFields.includes(selectFields[i])) {
          } else {
            sameFlag = false;
            break;
          }
        }
        if (sameFlag) {
          //如果跟初始的字段一致就不需要保存。包括全部的，全部的可以是没有，也可以是全部保存
          return;
        }
      }

      let selectedColumns = {};

      this.dataLoading = true;
      selectedColumns.page_table_type = this.pageTableType;
      selectedColumns.field_names = selectFields;
      console.log(this.pageTableType, "此处是pageTableType");
      this.http
        .post(saveColumnUrl, selectedColumns)
        .then(resp => {
          this.initFields = selectFields;
          console.log("Save Select Column Success");
          this.dataLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.dataLoading = false;
        });
    },
    toggleSelection(mySelection, flag) {
      for (let i in mySelection) {
        this.$refs.basicFormTable.toggleRowSelection(mySelection[i], true);
      }
    },
    clearSelection() {
      this.$refs.basicFormTable.clearSelection();
    },
    showImportDetail() {
      this.$emit("showImportDetail");
    },
    // 是否开启组织架构树 或者 定制化下拉列表
    inputType(key) {
      let type = "input";
      switch (this.dataFacetKey) {
        // to do list
        case "poh_mytodolist":
          if (["detail_owner"].includes(key)) {
            type = "tree";
          }
          break;
        // to do list 代理
        case "poh_mytodolist_delegation":
          if (["delegated_user"].includes(key)) {
            type = "select";
          } else if (["detail_owner"].includes(key)) {
            type = "tree";
          }
          break;
        // clinic
        case "poh_clinic_employees_view":
          if (["detailer"].includes(key)) {
            type = "tree";
          }
          break;
        // clinic-master-data
        case "POH_CLINIC_MASTER_DATA_VIEW":
          if (["detailer"].includes(key)) {
            type = "tree";
          }
          break;
        // clinic 代理
        case "poh_clinic_employees_delegation_view":
          if (["detailer"].includes(key)) {
            type = "tree";
          } else if (["delegated_user"].includes(key)) {
            type = "select";
          }
          break;
        // 草稿箱
        case "poh_clinic_employees_draft_view":
          if (["detailer"].includes(key)) {
            type = "tree";
          }
          break;
        // 草稿箱 代理
        case "poh_draft_delegation_view":
          if (["detailer"].includes(key)) {
            type = "tree";
          } else if (["delegated_user"].includes(key)) {
            type = "select";
          }
          break;
        // Dental Professional
        case "poh_employees_view":
          if (["detailer"].includes(key)) {
            type = "tree";
          }
          break;
        // Dental Professional master data
        case "POH_DENTAL_PROFESSIONAL_MASTER_DATA_VIEW":
          if (["detailer"].includes(key)) {
            type = "tree";
          }
          break;
        // Dental Professional 代理
        case "poh_employees_delegation_view":
          if (["delegated_user"].includes(key)) {
            type = "select";
          } else if (["detailer"].includes(key)) {
            type = "tree";
          }
          break;
        // 代理
        case "poh_delegation_view":
          if (["name", "delegated_name", "create_by"].includes(key)) {
            type = "allTree";
          }
          break;
        // 代理 代理人
        case "poh_delegationx2_view":
          if (["name", "delegated_name", "create_by"].includes(key)) {
            type = "allTree";
          } else if (["delegated_user"].includes(key)) {
            type = "select";
          }
          break;
        default:
          break;
      }
      return type;
    },
    // 切换当前代理人账号
    changeDelegation(value, item) {
      let options = item.field_optional_value_list;
      let checkItem = options.find(it => it.option_value === value);
      // 设置代理人信息，为了写进请求头
      let obj = {
        "DELEGATED-USERNAME": checkItem.option_value,
        "DELEGATED-ROLE": checkItem.option_role,
      };
      localStorage.setItem('current_delegation', JSON.stringify(obj));
      setTimeout(() => {
        this.getBusinessOrgTree();
        this.queryDelegationOrgTree();
        this.runQuery();
      }, 0);
    },
    // 获取poh 业务树
    getBusinessOrgTree() {
      let that = this;

      return new Promise((reslove, reject) => {
        this.http
          .get(`${this.baseStoreUrl}/poh/org/getBusinessOrgTree`)
          .then((res) => {
           let orgTree = cloneDeep(res.data);
            that.businessOrgTree = orgTree ? orgTree : [];
            if (this.$refs.pohOrgTree) {
              for (let index = 0; index < this.$refs.pohOrgTree.length; index++) {
                that.$refs.pohOrgTree[index].updateData(orgTree);
              }
            }
            let data = res.data[0] ? res.data[0] : [];
            if(this.dataFacetKey ==='poh_clinic_employees_delegation_view' || this.dataFacetKey==='poh_draft_delegation_view'){
              if(data.role === 'Oral Care Professional Detailer' ){
                this.tableOperationButtonList = [
                  {
                    label: "编辑", //按钮显示的名称
                    type: "text", //按钮的类型
                    name: "edit", // 按钮点击时间触发的函数名称
                    width: 100,
                  },
                  {
                    label: "撤回", //按钮显示的名称
                    type: "text", //按钮的类型
                    name: "recall", // 按钮点击时间触发的函数名称
                    width: 100,
                  },
                ];
                this.showTableOperationButton = true;

                this.toolbarButtonList = [
                  {
                    label: "导出", //按钮显示的名称
                    type: "primary", //按钮的类型
                    name: "export", // 用户点击时返回的组件
                    elColWidth: 3, //按钮的占位
                    loading: false, //防止重复点击
                  },{
                  label: "新增诊所 ", //按钮显示的名称
                  type: "primary", //按钮的类型
                  name: "created", // 用户点击时返回的组件
                  elColWidth: 3, //按钮的占位
                  loading: false, //防止重复点击
                }];
                this.showToolbarButtonList = true;
              }else{
                this.tableOperationButtonList = [];
                this.showTableOperationButton = false;
                this.showToolbarButtonList = false;
                this.toolbarButtonList = [
                  {
                    label: "导出", //按钮显示的名称
                    type: "primary", //按钮的类型
                    name: "export", // 用户点击时返回的组件
                    elColWidth: 3, //按钮的占位
                    loading: false, //防止重复点击
                  }];
              }
            }

            if(this.dataFacetKey ==='poh_mytodolist_delegation'){
              if(data.role === 'Channel Leader' ){
                this.toolbarButtonList = [
                  {
                    label: "批量审批 ", //按钮显示的名称
                    type: "primary", //按钮的类型,默认空,支持  primary，success，info，warning，danger
                    name: "pohApprove", // 关键字
                    elColWidth: 3, //按钮的占位
                    loading: false, //防止重复点击
                  },
                ]
                this.showToolbarButtonList = true;
              }else{
                this.toolbarButtonList = [];
                this.showToolbarButtonList = false;

              }
            }

            reslove(true);
          })
          .catch((err) => {
            console.log(err);
            reslove(true);
          });
      })
    },
    // 获取poh 代理树
    queryDelegationOrgTree() {
      return new Promise((reslove, reject) => {
        let params = {
          start_time: null,
          need_time: false,
          end_time:  null,
        };
        this.http
          .post(`${this.baseStoreUrl}/poh/org/queryDelegationOrgTree`, params)
          .then((res) => {
            this.delegationOrgTree = res.data ? res.data : [];
            reslove(true);
          })
          .catch((err) => {
            console.log(err);
            reslove(true);
          });
      })
    },
    getStatus(row){ //获取每行某个字段的状态来控制某个按钮的是否可点击，tableOperationButtonList中的needDisabled为true才会触发这个事件
      let disabled = false
      this.$emit('getStatus',row,val=>{
        disabled=val
      })
      return disabled
    }

  },
  mounted() {}
};
</script>

<style scoped>
div /deep/ .el-tree-node__content .el-checkbox {
  margin-bottom: 0;
}
.mytodolistControlOverflow div[0] {
  display: inline-block;
  white-space: nowrap;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.text-right {
  text-align: right;
  margin-right: 100px;
}

.adapt-top {
  margin-top: 10px;
}

.adapt-bottom {
  margin-bottom: 10px;
}

.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 12px 0;
  border-radius: 4px;
}

.adapt-bottom {
  margin-bottom: 20px;
}

.templet {
  color: #ffffff;
}

.e-label {
  font-weight: bold;
}

.name {
  font-size: 16px;
  padding: 5px 0;
  float: left;
}

.product-name {
  margin-bottom: 20px;
}

.width-adapt {
  width: 500px;
}

.el-table .warning-row {
  background: oldlace;
}

.table /deep/ .current-row > td {
  /*background: rgba(0, 158, 250, 0.219) !important;*/
  background: deepskyblue;
}

/*.table .success-row {*/
/*!*background: #f0f9eb;*!*/
/*background: red;*/

/*}*/

.success-row {
  background: #f0f9eb;
}

.el-date-editor--daterange.el-input,
.el-date-editor--daterange .el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
  /*height: 26px;*/
  /*margin-top: 8px;*/
}

.el-form--label-top /deep/ .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 0 10px;
  line-height: 10px;
  font-size: 12px;
  margin-bottom: -16px;
}

/deep/ .el-input--small .el-input__inner {
  height: 32px !important;
  line-height: 32px;
}

.el-select-small /deep/ .el-input--small /deep/ .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.el-range-editor--small .el-range__close-icon,
/deep/ .el-range-editor--small .el-range__icon {
  line-height: 20px;
}

/*.el-date-editor /deep/ .el-range-separator {*/
/*  line-height: 20px;*/
/*  width: 5%;*/
/*  color: #303133;*/
/*  font-size: 12px;*/
/*}*/

.cell-value {
  cursor: pointer;
  color: #1c15ff;
  text-decoration: underline;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 6px 0;
}

/deep/ .el-table {
  font-size: 12px;
}

/deep/ .el-table thead {
  /* color: black; */
}

/*/deep/ .el-input__prefix .el-input__icon{*/
/*  width:10px;*/
/*  line-height: 40px;*/
/*}*/

/*/deep/ .el-input--prefix .el-input__inner{*/
/*  padding-left: 18px;*/
/*}*/

/*/deep/ .el-input--suffix .el-input__inner{*/
/*  padding-right: 5px;*/
/*}*/

/deep/ .el-collapse-item__content {
  padding-bottom: 10px;
}

/deep/ .el-form-item {
  margin-bottom: 0px;
}

/deep/ .el-collapse-item__header {
  height: 35px;
  line-height: 35px;
}

.data-region {
  /*box-shadow:2px 2px  5px 3px lightgray;*/
  margin-top: 10px;
}

.tool-bar,
/deep/ .el-table {
  /* padding-left: 5px; */
  /* padding-right: 5px; */
}

/deep/ .el-table {
  width: auto;
}

.el-select {
  width: 100%;
}

/deep/ .el-table th {
  /* background-color: #e5e9ec94; */
}

/deep/ .el-table__empty-text {
  font-size: 15px;
}

.search-reset {
  text-align: right;
  margin-top: 22px;
}

.data-region /deep/ .el-button--mini {
  min-width: 70px;
}

.dialog-footer /deep/ .el-button {
  padding: 7px 20px;
}

.el-tree {
  max-height: 350px !important;
  overflow: auto;
}

.el-table /deep/ .warning-row {
  background: oldlace;
}

.el-table /deep/ .success-row {
  background: #f0f9eb;
}
.el-table /deep/ .primary-row {
  background: #d9e9f9;
}

.el-form .el-select /deep/ .el-tag {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.view-pic {
  color: blue;
  cursor: pointer;
  font-size: 14px;
}
.avatar {
  width: 132px;
  height: 132px;
  display: block;
  border-radius: 6px;
}
.ticket-mark {
  color: red;
  position: absolute;
  left: 0px;
  bottom: -22px;
  font-size: 12px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/d1/d1-vue-component.vue